module.exports = __webpack_public_path__ + "img/chores.19c1e34a.svg";